/* eslint-disable  @typescript-eslint/no-explicit-any */
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import ErrorTypes from './errorTypes';

declare global {
    interface Window {
        dataLayer: any[];
    }
}

interface DataLayerVariable {
    [key: string]: any;
}
export const piwikPrefix = 'kreditt-boliglaansoeknad';

export type errorEvent = {
    // eslint-disable-next-line camelcase
    error_name: string;
    // eslint-disable-next-line camelcase
    error_description: string;
    // eslint-disable-next-line camelcase
    error_code: string;
};

const pushToDataLayer = <T extends DataLayerVariable>(variables: T) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...variables });
};

export interface ModalOverlayVariable extends DataLayerVariable {
    // eslint-disable-next-line camelcase
    modal_name: string;
    // eslint-disable-next-line camelcase
    modal_description: string;
    // eslint-disable-next-line camelcase
    modal_code: string;
}

export const pushErrorToDataLayer = (errorType: ErrorTypes, error: RequestExceptionWithResponse) => {
    const errorEvent: errorEvent = {
        error_name: errorType,
        error_code: error.code,
        error_description: error.errorName,
    };
    pushToDataLayer({ event: 'error', ...errorEvent });
};

export const pushModalOverlayToDataLayer = (modalEvent: ModalOverlayVariable) => {
    pushToDataLayer({ event: 'modal', ...modalEvent });
};
